import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

// Cache the site title to avoid repeated fetches
let cachedSiteTitle: string | null = null;
let titlePromise: Promise<string | null> | null = null;

const fetchSiteTitleFromDB = async (): Promise<string | null> => {
  const { data, error } = await supabase
    .from('settings')
    .select('value')
    .eq('key', 'site_title')
    .maybeSingle();

  if (error && error.code !== 'PGRST116') {
    console.error('Error loading site settings:', error);
    return null;
  }

  return (data?.value && typeof data.value === 'string') ? data.value : 'BeauBox';
};

export const useSiteSettings = () => {
  const [siteTitle, setSiteTitle] = useState<string>(cachedSiteTitle || 'BeauBox');
  const [loading, setLoading] = useState(!cachedSiteTitle);

  useEffect(() => {
    // If we already have a cached value, use it
    if (cachedSiteTitle !== null) {
      setLoading(false);
      return;
    }

    // If a fetch is already in progress, wait for it
    if (titlePromise) {
      titlePromise.then((title) => {
        if (title) {
          cachedSiteTitle = title;
          setSiteTitle(title);
        }
        setLoading(false);
      });
      return;
    }

    // Start a new fetch
    titlePromise = fetchSiteTitleFromDB();
    titlePromise.then((title) => {
      if (title) {
        cachedSiteTitle = title;
        setSiteTitle(title);
      }
      setLoading(false);
      titlePromise = null;
    });
  }, []);

  const updateSiteTitle = (title: string) => {
    cachedSiteTitle = title;
    setSiteTitle(title);
  };

  return { siteTitle, loading, updateSiteTitle };
};